import { useEffect, useState } from 'react';

/**
 * Custom hook to parse and track the search term from querySummary
 * Removes distance filters and extracts the main search query
 * @param {Object} querySummary - The querySummary controller from Coveo
 * @returns {string} The parsed search term
 */
export const useParsedSearchTerm = (querySummary) => {
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (!querySummary) {
            return;
        }

        return querySummary.subscribe(() => {
            const { query } = querySummary.state;
            const parsedSearchTerm =
                query
                    ?.replace(/@mydistanceinmiles\s*<=\s*\d+/g, '')
                    ?.split('AND')?.[0]
                    ?.trim() || '';
            setSearchTerm(parsedSearchTerm);
        });
    }, [querySummary]);

    return searchTerm;
};
